import { AskDataIndexing, IDataSourceBase } from '~src/ts/models/IDataSourceInfo';
import { DataSources } from '~src/content/resources/Datasources';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { ISetDatasourceAskDataSettingsParams } from '~src/ts/ServerApi/requests/SetDatasourceAskDataSettingsRequest';
import { FeatureFlags } from '~src/ts/FeatureFlags';

export namespace ChangeDatasourceAskDataAction {

  export function execute(datasource: IDataSourceBase, indexing: AskDataIndexing, feedbackToCurator: boolean): Promise<IResult> {
    const params: ISetDatasourceAskDataSettingsParams = {
      id: Number(datasource.id),
      indexing: indexing,
    };
    if (FeatureFlags.nlFeedbackToCuratorEnabled) {
      params.feedbackToCuratorEnabled = feedbackToCurator;
    }

    return DataSources.setAskDataSettings(params).then(response => {
      if (response.errors && response.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: Messages.dataSourceNlpSetting_failed() });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.datasourceAskData_edit_sucessful() });
      }
      return response;
    });
  }
}

export type ChangeDatasourceAskDataAction = typeof ChangeDatasourceAskDataAction;
